import { render, staticRenderFns } from "./New_UploadDoc.vue?vue&type=template&id=5a2a0c1d&scoped=true&"
import script from "./New_UploadDoc.vue?vue&type=script&lang=js&"
export * from "./New_UploadDoc.vue?vue&type=script&lang=js&"
import style0 from "./New_UploadDoc.vue?vue&type=style&index=0&id=5a2a0c1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a0c1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
